<template>
  <div>
    <el-dialog title="品名试算"
              width="420px"
              :visible.sync="visibleValue"
              :close-on-press-escape="false"
              :close-on-click-modal="false"
              :modal-append-to-body="true"
              :append-to-body="true"
              @opened="openedCallback"
              @closed="closedCallback">
      <el-form :model="searchData"
              ref="searchForm"
              label-width="90px"
              class="demo-ruleForm">
        <el-form-item label="国家" prop="countryId" :rules="formRules.require">
          <el-select
            v-model="searchData.countryId"
            filterable
            @change="changeCountry"
            :loading="loadingCountryList"
            :disabled="disabledCountry"
            placeholder="请选择国家"
            class="select-country"
          >
            <el-option
              style="width: 260px;"
              v-for="item in countryList"
              :key="item.id"
              :label="item.namec"
              :value="item.id"
            />
          </el-select>
          <el-button type="primary"
                     @click="showProductPreview"
                     class="btn-preview">产品品名预览表</el-button>
        </el-form-item>
        <el-form-item label="产品品名" prop="productName" class="is-required">
          <el-select
            v-model="currentProductNameData"
            value-key="id"
            filterable
            remote
            clearable
            :remote-method="remoteMethodProduct"
            @focus="handleFocusProduct"
            @change="changeProductName"
            :loading="loadingProductNameList||loadingFilterCountry"
            :disabled="!searchData.countryId"
            placeholder="请输入中文或英文品名"
            :no-data-text="noDataHintText"
            class="input-product-name"
          >
            <!--          <p slot="empty"-->
            <!--             class="el-select-dropdown__empty"-->
            <!--             style="padding: 10px;">{{ noDataHintText }}</p>-->
            <el-option
              v-for="item in productNameList"
              :key="item.id"
              :label="item.namec"
              :value="item"
              class="product-name--item">
              <span class="product-name--item-name">{{item.namec}}</span>
              <span class="product-name--item-value"><span class="added-text">加收</span> <span class="color-primary">{{item.currency||"CNY"}} {{item.price||"0"}}</span></span>
            </el-option>
          </el-select>
          <!--        <el-input v-model="searchData.productName"-->
          <!--                  placeholder="请输入中文或英文品名"-->
          <!--                  class="input-product-name"/>-->
        </el-form-item>
        <el-form-item label="海关编码" prop="hsCode" :rules="formRules.hsCode">
          <el-input v-model="searchData.hsCode"
                    :disabled="!searchData.countryId"
                    placeholder="海关编码(选填)"
                    @change="changeHsCode"
                    class="input-hs-code"/>
        </el-form-item>
        <el-form-item label=" " prop="">
          <el-button
            @click="clickConfirm"
            :disabled="!searchData.productName"
            type="primary"
            class="btn-confirm"
          >我知道了</el-button>
        </el-form-item>

        <el-alert
          title="温馨提示：您当前查找的产品品名附加费为平台价格，产品附加费会根据不同的品名收取不同费用。"
          type="warning"
          show-icon>
        </el-alert>
      </el-form>
    </el-dialog>
    <product-name-preview
      :visible.sync="visibleProductNamePreview"
      :countryList="countryList"
    />
  </div>
</template>

<script>
import {mixinsDialog} from "my-element-mixins";
// import {getEndList} from "@/commonQuery/reqeustBaseData";
import {debounce} from "my-tools-kit/src/modules/debounce";
  import {rulesNotEmpty} from "@/assets/js/formRules";
import ProductNamePreview from "@common/productNamePreview";

export default {
  name: "queryProductName",
  mixins:[mixinsDialog],
  props:{
    closeClearData:{
      type:Boolean,
      default:false,
    },//关闭时是否清空历史数据
    needCustomsClearance:Boolean,// 品名试算 是否 有清关相关逻辑
    defaultCountryId:[String,Number],// 品名试算 默认选中国家id,值不为空时，国家选中框禁用
    defaultGroupId:[String,Number],// 品名试算 默认团id,跟团详情页需要
  },
  components: {ProductNamePreview},
  data(){
    // 校验必填不能为空、不能小于0的number
    let checkHsCode  = (rule, value, callback)=>{
      if(!value && value !==0) return callback();
      const isNumber = /^[\d]{0,10}$/.test(value);
      if(!isNumber) return callback(new Error('只能输入10位以内（含）数字的海关编码'));
      callback();
    };
    return {
      searchData:{
        countryId:"",//国家id
        productName:"",//产品品名
        hsCode:"",//海关编码
      },
      /*校验*/
      formRules: {
        no: [{trigger: "blur", required: false}],
        require: [rulesNotEmpty()],
        hsCode:[
          {trigger: ["blur"],validator:checkHsCode,}
        ],
      },
      /* 目的国 */
      loadingCountryList:false,
      loadingFilterCountry:false,
      countryList:[],
      baseCountryList:[],
      disabledCountry:false,
      /* 产品品名 */
      currentProductNameData:{},
      loadingProductNameList:false,
      productNameList:[],
      visibleProductNamePreview: false
    }
  },
  computed:{
    /**
     * 产品品名没有匹配项时，展示的不同提示
     */
    noDataHintText(){
      if(this.searchData.hsCode) return `未匹配到海关编码为[${this.searchData.hsCode}]的相关产品品名`
      return "无数据"
    },
  },
  watch:{
    defaultCountryId:{
      immediate:true,
      handler(newVal){
        this.searchData.countryId = newVal;
        this.disabledCountry = !!newVal;
        this.changeCountry();
      },
    },
  },
  methods:{
    /**
     * 关闭回调
     */
    closedCallback() {
      if(this.closeClearData){
        let keys = Object.keys(this.searchData);
        keys.forEach(key => this.searchData[key] = "" );

        this.loadingCountryList = false;
        this.loadingFilterCountry = false;
        this.countryList = this.baseCountryList;

        this.loadingProductNameList = false;
        this.productNameList = [];
      }
      this.$emit('closed');
    },
    /**
     * 显示回调
     */
    openedCallback(){
      if(this.$refs.searchForm && this.$refs.searchForm.clearValidate) this.$refs.searchForm.clearValidate();
    },
    /**
     * 获取目的国列表
     */
    getCountryList(){
      this.loadingCountryList = true;
      this.axios.get('/api/filedata/findCountryAndEUCity').then( res=> {
          this.loadingCountryList = false;
          const list = res.data.datas||[];
          this.countryList = list;
          this.baseCountryList = list;
          return res
        })
        .catch(res=>{
          this.loadingCountryList = false;
        })
    },
    /**
     * 变更 目的国
     */
    changeCountry(value){
      this.searchData.productName = "";
      this.currentProductNameData = {};
      this.remoteMethodProduct();
    },
    /**
     * 筛选 目的国
     */
    filterCountry(value){
      this.loadingFilterCountry = true;
      if(!value && value !== 0) {
        this.countryList = this.baseCountryList;
        this.loadingFilterCountry = false;
        return true;
      }
      value = value.toLowerCase();
      this.countryList = this.baseCountryList.filter(item=>{
        let namec =`${item.namec||""}`.toLowerCase();
        // let namee =`${item.namee||""}`.toLowerCase();
        // let code =`${item.code||""}`.toLowerCase();
        // return namec.match(value) || namee.match(value) || code.match(value);
        return namec.match(value);
      })
      this.loadingFilterCountry = false;
    },
    /**
     * 目的国 输入框获得焦点
     */
    handleFocusCountry(){
      this.filterCountry();
    },
    /**
     * 海关编码失去焦点
     */
    changeHsCode(value){
      // this.searchData.productName = "";
      // this.currentProductNameData = {};
      // this.productNameList = [];
    },
    /**
     * 筛选 产品名
     * @param value
     */
    remoteMethodProduct(value){
      this.loadingProductNameList = true;
      if(!value && value !== 0 ){
        this.loadingProductNameList = false;
        this.productNameList = [];
        return true;
      }
      this.queryProductNameList(value);
    },
    queryProductNameList:debounce(function(productName=""){
      let url = "/api/product/listProductTrial";
      let countryId = this.searchData.countryId;
      let customsCode = `${this.searchData.hsCode||""}`;
      if(!countryId && countryId !== 0){
        return this.$message.error('请先选择国家');
      }
      if(customsCode){
        const isNumber = /^[\d]{0,10}$/.test(customsCode);
        if(!isNumber) return this.$message.error('只能输入10位以内（含）数字的海关编码');
      }
      let data = {
        "countryId": countryId,//国家id
        // "customsCode": customsCode,//海关编码
        // "groupId": undefined,
        "name": productName,//产品名
      };
      console.log(this.$route)
      if(this.needCustomsClearance){
        url = "/api/product/listGroupProductTrial";
        if(this.defaultGroupId) data.groupId = this.defaultGroupId;
        // let joinGroupPaths = [
        //   "/queryJoinProductDetails",//跟团详情页
        //   "/orderGroup",//跟团下单页
        // ];
        // if(joinGroupPaths.includes(this.$route.path)){
        //   let query =  this.$route.query;
        //   if(query.id) data.groupId = query.id;
        // }
      }
      console.log("productName",productName)
      return this.axios.post(url,data)
        .then(res=>{
          res = res.data ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res=>{
          this.loadingProductNameList = false;
          let list = res.datas || [];
          list.forEach(item=>item.price=item.surcharge);
          this.productNameList = list;
        })
        .catch(res=>{
          this.loadingProductNameList = false;
          this.productNameList = [];
        })
    },500,false),
    testProductNameList(productName=""){
      function createItem(index){
        return {
          id:Date.now() + `_${index+1}`,
          namec:`产品_${productName}_${index+1}`,
          namee:`product_${productName}_${index+1}`,
          // billingUnit:["KG","CBM","车","PLTS"][Math.floor(Math.random() * 10)%4],
          currency:["CNY","USD"][Math.floor(Math.random() * 10)%3],
          price: Math.round(Math.random() * 1000)/100,
        };
      }
      let list = Array(Math.floor(Math.random() * 10)).fill(1);
      list = list.map((item,index)=>createItem(index));
      return Promise.resolve({
        data:{
          code:200,
          datas:list,
          message:"ok",
        }
      })
    },
    /**
     * 变更 产品品名
     */
    changeProductName(item = {}){
      console.log(`changeProductName()`,item)
      this.searchData.productName = item.namec;
    },
    /**
     * 产品品名输入框获得焦点
     */
    handleFocusProduct(){
      this.remoteMethodProduct(this.searchData.productName);
    },
    /**
     * 点击 确认
     */
    clickConfirm(){
      this.closedDialog();
    },
    showProductPreview() {
      this.visibleProductNamePreview = true
    }
  },
  mounted() {
    this.getCountryList();
  },
}
</script>

<style scoped lang="scss">
$input-width:260px;
.select-country{
  // width: $input-width;
  width: $input-width - 140px;
}
.input-product-name{
  //width: 210px;
  //margin-right: 12px;
  width: $input-width;
}
.input-hs-code{
  //width: 136px;
  width: $input-width;
}
.btn-confirm{
  width: $input-width - 90px;
}
.product-name{
  &--item{
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    max-width: 360px;
    &:not(.selected) .added-text{
      color: #999;
    }
  }
  &--item-name{
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &--item-value{
    //color: #FF4D01;
    margin-left: 10px;
  }
}
.btn-preview {
  width: $input-width - 120px;
}
</style>



// WEBPACK FOOTER //
// common/queryProductName/index.vue